import { gql } from '@apollo/client';

export const LIST_LABOR_TEAM_NAMES = gql`
    query ListLaborTeamNames($hubId: Long!) {
        listLaborTeamNames(hubId: $hubId)
    }
`;

export interface ListLaborTeamNamesResponse {
    listLaborTeamNames: string[];
}

export const RECENT_LABOR_TEAM_TAG_LIMIT = 5;

export const LIST_RECENT_LABOR_TEAM_NAMES = gql`
    query ListRecentLaborTeamNames($hubId: Long!, $limit: Int!) {
        listRecentLaborTeamNames(hubId: $hubId, limit: $limit)
    }
`;

export interface ListRecentLaborTeamNamesResponse {
    listRecentLaborTeamNames: string[];
}
